import React from 'react';
import { useReactTable, getCoreRowModel, flexRender } from '@tanstack/react-table';
import { Box, Flex, Icon } from "@chakra-ui/react";
import { TableResponsive, Button } from '../lib';
import PropTypes from 'prop-types';

function Table({ columns, data, pagination, totalItems, getNextPage, hasNext, getPreviousPage, hasPrevious, hiddenColumns = [] }) {

    const table = useReactTable({
        columns,
        data,
        getCoreRowModel: getCoreRowModel(),
        initialState: { columnVisibility: hiddenColumns.reduce((acc, col) => ({ ...acc, [col]: false }), {}) }
    })

    return (
        <div>
            <TableResponsive>
                <table>
                    <thead>
                        {table.getHeaderGroups().map(headerGroup => (
                            <tr key={headerGroup.id}>
                                {headerGroup.headers.map(header => (
                                    <th key={header.id}>
                                        {header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody>
                        {table.getRowModel().rows.map(row => (
                            <tr key={row.id}>
                                {row.getVisibleCells().map(cell => (
                                    <td
                                        key={cell.id}
                                        data-label={typeof cell.column.columnDef.header === 'string' ? cell.column.columnDef.header : ''}
                                    >
                                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </TableResponsive>
            {pagination ?
                <div>
                    <Flex flexWrap='wrap' justifyContent={['start','space-between']} align="center">
                        <Box mb={[3,0,0]} mr={4}> TOTAL: {totalItems} </Box>
                        <Flex w={['100%','auto']}>
                            <Button m={'0 4px'} size="sm" onClick={() => getPreviousPage()} variant={'default'} disabled={!hasPrevious} aria-label="Previous">
                                    <Icon name="chevron-left" size="20px"/>
                                    Anterior
                            </Button>
                            <Button m={'0 4px'} size="sm" onClick={() => getNextPage()} variant={'default'} disabled={!hasNext} aria-label="Next">
                                    Siguiente
                                    <Icon name="chevron-right" size="20px"/>
                            </Button>
                        </Flex>
                    </Flex>
                </div> 
                : <Box mr={4}> TOTAL: {totalItems} </Box>
            }
        </div>
    )
}

Table.defaultProps = {
    hiddenColumns: []
}

Table.propTypes = {
    columns: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    pagination: PropTypes.bool.isRequired,
    totalItems: PropTypes.number.isRequired,
    getNextPage: PropTypes.func,
    hasNext: PropTypes.bool,
    getPreviousPage: PropTypes.func,
    hasPrevious: PropTypes.bool,
    hiddenColumns: PropTypes.array
}

export default Table;